import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function GestioneBandi() {
  const [openFaq, setOpenFaq] = useState(null);
  const [formData, setFormData] = useState({ nome: '', email: '', telefono: '', azienda: '', messaggio: '' });
  const [formStatus, setFormStatus] = useState(null);
  const [sending, setSending] = useState(false);
  const [checkoutLoading, setCheckoutLoading] = useState(false);

  const handleCheckout = async () => {
    if (checkoutLoading) return;
    setCheckoutLoading(true);
    try {
      const res = await axios.post('/api/create-checkout-session', {
        amount: 1000,
        type: 'gestione-bandi'
      });
      if (res.data.url) {
        window.location.href = res.data.url;
      }
    } catch (err) {
      console.error('Errore checkout:', err);
      alert('Errore durante il pagamento. Riprova tra qualche istante.');
    } finally {
      setCheckoutLoading(false);
    }
  };

  useEffect(() => {
    axios.post('/api/funnel/event', { evento: 'visita_gestione_bandi', pagina: '/gestione-bandi' }).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post('/api/contact', {
        ...formData,
        tipo: 'gestione_bandi',
        messaggio: `[RICHIESTA GESTIONE BANDI] ${formData.messaggio}`
      });
      setFormStatus('success');
      setFormData({ nome: '', email: '', telefono: '', azienda: '', messaggio: '' });
    } catch {
      setFormStatus('error');
    }
    setSending(false);
  };

  const faqs = [
    {
      q: 'Cosa include esattamente il servizio di Gestione Bandi?',
      a: 'Il servizio include: analisi approfondita della tua azienda e dei bandi compatibili, preparazione completa della documentazione tecnica e amministrativa, compilazione e presentazione della domanda sui portali ufficiali, gestione delle integrazioni richieste dall\'ente erogatore, e follow-up fino all\'esito finale della pratica.'
    },
    {
      q: 'Quanto costa il servizio?',
      a: 'Il costo è composto da due parti: un anticipo di €1.000 + IVA per l\'avvio della pratica (che copre l\'analisi e la preparazione documentale), più il 5% sull\'importo effettivamente deliberato (approvato) dall\'ente erogatore. Se il bando non viene approvato, non dovrai pagare la percentuale sul deliberato.'
    },
    {
      q: 'Cosa succede se la domanda viene respinta?',
      a: 'In caso di rigetto, avrai comunque ricevuto l\'analisi completa e la documentazione preparata. La percentuale del 5% è dovuta solo sull\'importo effettivamente approvato e deliberato. Il nostro tasso di successo è superiore al 90%, grazie alla selezione accurata dei bandi e alla qualità della documentazione.'
    },
    {
      q: 'Quanto tempo richiede la preparazione della pratica?',
      a: 'I tempi variano in base alla complessità del bando e alla disponibilità della documentazione aziendale. In media, la preparazione richiede dai 5 ai 15 giorni lavorativi. Per bandi con scadenze ravvicinate, offriamo un servizio prioritario.'
    },
    {
      q: 'Posso richiedere il servizio per più bandi contemporaneamente?',
      a: 'Assolutamente sì. Anzi, spesso i bandi sono cumulabili tra loro e presentare più domande contemporaneamente massimizza le possibilità di ottenere finanziamenti. Per ogni bando aggiuntivo, l\'anticipo è ridotto a €800 + IVA.'
    },
    {
      q: 'Devo aver acquistato il Report per richiedere questo servizio?',
      a: 'Il Report Personalizzato (€197) è il punto di partenza ideale perché identifica i bandi compatibili con la tua azienda. Tuttavia, se hai già individuato un bando specifico, possiamo valutare direttamente la fattibilità durante la consulenza gratuita iniziale.'
    },
    {
      q: 'Che tipo di bandi gestite?',
      a: 'Gestiamo tutti i principali bandi nazionali, regionali e provinciali: contributi a fondo perduto, crediti d\'imposta, finanziamenti agevolati, voucher per l\'innovazione, bandi PNRR, e molto altro. Il nostro database copre oltre 75 incentivi attivi.'
    },
    {
      q: 'Come posso iniziare?',
      a: 'Puoi contattarci tramite WhatsApp al +39 348 493 2900 per una consulenza gratuita, oppure compilare il modulo in fondo a questa pagina. Ti ricontatteremo entro 24 ore lavorative per valutare insieme le migliori opportunità per la tua azienda.'
    }
  ];

  const steps = [
    {
      num: '1',
      title: 'Consulenza Gratuita',
      desc: 'Analizziamo insieme il tuo profilo aziendale e identifichiamo i bandi più adatti. Nessun costo, nessun impegno.',
      icon: '🔍'
    },
    {
      num: '2',
      title: 'Analisi di Fattibilità',
      desc: 'Verifichiamo requisiti, documentazione necessaria e probabilità di successo per ogni bando selezionato.',
      icon: '📋'
    },
    {
      num: '3',
      title: 'Preparazione Documentazione',
      desc: 'Redigiamo tutta la documentazione tecnica e amministrativa richiesta dal bando, con precisione millimetrica.',
      icon: '📄'
    },
    {
      num: '4',
      title: 'Presentazione Domanda',
      desc: 'Compiliamo e presentiamo la domanda sui portali ufficiali, rispettando ogni requisito formale e scadenza.',
      icon: '🚀'
    },
    {
      num: '5',
      title: 'Follow-up e Gestione',
      desc: 'Monitoriamo lo stato della pratica, gestiamo eventuali integrazioni e ti aggiorniamo fino all\'esito finale.',
      icon: '✅'
    }
  ];

  const testimonials = [
    {
      quote: 'Avevo individuato un bando regionale ma non sapevo da dove iniziare con la documentazione. Il team di VerificaIncentivi ha gestito tutto in modo impeccabile: 35.000€ di contributo approvato in meno di 60 giorni.',
      author: 'Marco B.',
      role: 'Titolare, Azienda Agricola — Sicilia',
      amount: '€35.000'
    },
    {
      quote: 'Grazie al servizio di gestione bandi ho ottenuto il Credito d\'Imposta Transizione 5.0 per l\'acquisto di nuovi macchinari. Senza il loro supporto non avrei mai completato la pratica in tempo.',
      author: 'Francesca L.',
      role: 'CEO, Startup Tecnologica — Milano',
      amount: '€78.000'
    },
    {
      quote: 'Professionalità e trasparenza assoluta. L\'anticipo di 1.000€ è stato l\'investimento migliore dell\'anno: abbiamo ottenuto un contributo a fondo perduto di 120.000€ per il nostro progetto di espansione.',
      author: 'Antonio D.',
      role: 'Direttore, Impresa Manifatturiera — Veneto',
      amount: '€120.000'
    }
  ];

  return (
    <div className="fade-in">
      {/* Hero Section */}
      <section className="landing-hero" style={{ padding: '80px 0', background: 'linear-gradient(135deg, #1a56db 0%, #0f3a8e 50%, #16a34a 100%)' }}>
        <div className="container" style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
          <div style={{ display: 'inline-block', background: 'rgba(255,255,255,0.15)', padding: '6px 16px', borderRadius: 20, fontSize: 13, fontWeight: 600, color: 'white', marginBottom: 20 }}>
            Servizio Professionale di Gestione Bandi
          </div>
          <h1 style={{ fontSize: 44, fontWeight: 800, color: 'white', lineHeight: 1.2, marginBottom: 20, maxWidth: 800, margin: '0 auto 20px' }}>
            Non Perdere Neanche un Euro di Incentivi:<br />
            <span style={{ color: '#86efac' }}>Ci Pensiamo Noi a Tutto</span>
          </h1>
          <p style={{ fontSize: 19, color: 'rgba(255,255,255,0.9)', maxWidth: 650, margin: '0 auto 32px', lineHeight: 1.7 }}>
            Dalla documentazione alla presentazione della domanda, il nostro team di esperti gestisce l'intero iter burocratico per farti ottenere i contributi che meriti.
          </p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 40 }}>
            <a href="https://wa.me/393484932900?text=Salve%2C%20sono%20interessato%20al%20servizio%20di%20Gestione%20Bandi.%20Vorrei%20maggiori%20informazioni." className="btn btn-lg btn-green" style={{ fontSize: 17, padding: '16px 36px' }}>
              Richiedi Consulenza Gratuita
            </a>
            <a href="#come-funziona" className="btn btn-lg btn-outline" style={{ borderColor: 'white', color: 'white', fontSize: 17, padding: '16px 36px' }}>
              Scopri Come Funziona
            </a>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 48, flexWrap: 'wrap' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 36, fontWeight: 800, color: 'white' }}>90%+</div>
              <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.8)' }}>Tasso di Successo</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 36, fontWeight: 800, color: 'white' }}>€2.8M+</div>
              <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.8)' }}>Contributi Ottenuti</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 36, fontWeight: 800, color: 'white' }}>150+</div>
              <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.8)' }}>Pratiche Gestite</div>
            </div>
          </div>
        </div>
      </section>

      {/* Problema / Soluzione */}
      <section className="section" style={{ background: 'white' }}>
        <div className="container">
          <div className="grid-2" style={{ alignItems: 'center', gap: 48 }}>
            <div>
              <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 16, color: '#111827' }}>
                Hai Scoperto gli Incentivi Giusti.<br />
                <span style={{ color: '#dc2626' }}>Ma la Burocrazia Ti Blocca?</span>
              </h2>
              <p style={{ color: '#4b5563', lineHeight: 1.8, marginBottom: 16 }}>
                Ogni anno, <strong>miliardi di euro</strong> di incentivi restano non utilizzati perché le aziende non riescono a completare le pratiche in tempo o commettono errori formali nella documentazione.
              </p>
              <p style={{ color: '#4b5563', lineHeight: 1.8, marginBottom: 16 }}>
                Una domanda incompleta, un documento mancante, una scadenza saltata: basta un piccolo errore per perdere decine di migliaia di euro di contributi a cui avresti diritto.
              </p>
              <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 12, padding: 20, marginTop: 16 }}>
                <p style={{ margin: 0, fontWeight: 600, color: '#991b1b', fontSize: 15 }}>
                  Il 40% delle domande viene respinto per errori formali, non per mancanza di requisiti.
                </p>
              </div>
            </div>
            <div>
              <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 16, padding: 32 }}>
                <h3 style={{ fontSize: 22, fontWeight: 700, color: '#15803d', marginBottom: 16 }}>La Soluzione: Affidati a Noi</h3>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  {[
                    'Analisi approfondita dei requisiti',
                    'Documentazione tecnica impeccabile',
                    'Presentazione nei tempi corretti',
                    'Gestione integrazioni e follow-up',
                    'Paghi la success fee solo se approvato'
                  ].map((item, i) => (
                    <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 14, color: '#374151', fontSize: 15, lineHeight: 1.6 }}>
                      <span style={{ color: '#16a34a', fontSize: 20, flexShrink: 0, marginTop: 2 }}>&#10003;</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Come Funziona il Servizio */}
      <section id="come-funziona" className="section" style={{ background: '#f8fafc' }}>
        <div className="container">
          <h2 className="section-title">Come Funziona il Servizio</h2>
          <p className="section-subtitle">Un processo collaudato in 5 fasi per massimizzare le tue probabilità di successo</p>
          <div style={{ maxWidth: 800, margin: '0 auto' }}>
            {steps.map((step, i) => (
              <div key={i} style={{
                display: 'flex', gap: 24, alignItems: 'flex-start', marginBottom: i < steps.length - 1 ? 0 : 0,
                position: 'relative', paddingBottom: i < steps.length - 1 ? 40 : 0
              }}>
                {i < steps.length - 1 && (
                  <div style={{ position: 'absolute', left: 27, top: 56, bottom: 0, width: 2, background: '#e5e7eb' }} />
                )}
                <div style={{
                  width: 56, height: 56, borderRadius: '50%', flexShrink: 0,
                  background: 'linear-gradient(135deg, #1a56db, #16a34a)', color: 'white',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 24, fontWeight: 800, position: 'relative', zIndex: 1
                }}>
                  {step.num}
                </div>
                <div style={{ background: 'white', borderRadius: 12, padding: 24, flex: 1, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                    <span style={{ fontSize: 22 }}>{step.icon}</span>
                    <h3 style={{ fontSize: 18, fontWeight: 700, color: '#111827', margin: 0 }}>{step.title}</h3>
                  </div>
                  <p style={{ color: '#6b7280', fontSize: 14, lineHeight: 1.7, margin: 0 }}>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cosa Include */}
      <section className="section" style={{ background: 'white' }}>
        <div className="container">
          <h2 className="section-title">Cosa Include il Servizio</h2>
          <p className="section-subtitle">Un pacchetto completo per trasformare le opportunità in contributi reali</p>
          <div className="grid-3">
            {[
              {
                icon: '🔎',
                title: 'Analisi Approfondita',
                items: ['Verifica requisiti aziendali', 'Selezione bandi compatibili', 'Stima importi ottenibili', 'Valutazione probabilità di successo']
              },
              {
                icon: '📋',
                title: 'Preparazione Documentazione',
                items: ['Redazione business plan (se richiesto)', 'Compilazione modulistica ufficiale', 'Preparazione allegati tecnici', 'Revisione legale della domanda']
              },
              {
                icon: '📤',
                title: 'Presentazione e Follow-up',
                items: ['Caricamento sui portali ufficiali', 'Invio nei tempi previsti', 'Gestione richieste di integrazione', 'Monitoraggio fino all\'esito']
              }
            ].map((service, i) => (
              <div key={i} className="card" style={{ textAlign: 'center', padding: 32 }}>
                <div style={{ fontSize: 40, marginBottom: 16 }}>{service.icon}</div>
                <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 16, color: '#111827' }}>{service.title}</h3>
                <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left' }}>
                  {service.items.map((item, j) => (
                    <li key={j} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10, fontSize: 14, color: '#4b5563' }}>
                      <span style={{ color: '#16a34a', fontWeight: 700 }}>&#10003;</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="section" style={{ background: 'linear-gradient(135deg, #1a56db 0%, #0f3a8e 100%)', color: 'white' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 style={{ fontSize: 32, fontWeight: 700, marginBottom: 12 }}>Pricing Trasparente e Senza Sorprese</h2>
          <p style={{ fontSize: 17, opacity: 0.9, maxWidth: 600, margin: '0 auto 40px' }}>
            Il nostro modello di pricing allinea i nostri interessi ai tuoi: guadagniamo di più solo quando tu ottieni di più.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 32, flexWrap: 'wrap', maxWidth: 900, margin: '0 auto' }}>
            {/* Anticipo */}
            <div style={{
              background: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(10px)',
              borderRadius: 16, padding: 40, flex: '1 1 380px', maxWidth: 420,
              border: '1px solid rgba(255,255,255,0.2)'
            }}>
              <div style={{ fontSize: 14, fontWeight: 600, opacity: 0.8, marginBottom: 8, textTransform: 'uppercase', letterSpacing: 1 }}>Anticipo Avvio Pratica</div>
              <div style={{ fontSize: 56, fontWeight: 800, marginBottom: 8 }}>€1.000</div>
              <div style={{ fontSize: 14, opacity: 0.8, marginBottom: 24 }}>IVA inclusa — una tantum per bando</div>
              <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left' }}>
                {['Analisi di fattibilità completa', 'Preparazione documentazione', 'Compilazione domanda', 'Caricamento portali ufficiali'].map((item, i) => (
                  <li key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, fontSize: 14 }}>
                    <span style={{ color: '#86efac' }}>&#10003;</span> {item}
                  </li>
                ))}
              </ul>
            </div>
            {/* Success Fee */}
            <div style={{
              background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(10px)',
              borderRadius: 16, padding: 40, flex: '1 1 380px', maxWidth: 420,
              border: '2px solid #86efac', position: 'relative'
            }}>
              <div style={{
                position: 'absolute', top: -14, left: '50%', transform: 'translateX(-50%)',
                background: '#16a34a', color: 'white', padding: '4px 16px', borderRadius: 20,
                fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1
              }}>
                Paghi Solo se Approvato
              </div>
              <div style={{ fontSize: 14, fontWeight: 600, opacity: 0.8, marginBottom: 8, textTransform: 'uppercase', letterSpacing: 1 }}>Success Fee sul Deliberato</div>
              <div style={{ fontSize: 56, fontWeight: 800, marginBottom: 8 }}>5%</div>
              <div style={{ fontSize: 14, opacity: 0.8, marginBottom: 24 }}>sull'importo effettivamente approvato</div>
              <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left' }}>
                {['Follow-up con ente erogatore', 'Gestione integrazioni', 'Monitoraggio fino all\'esito', 'Nessun costo se non approvato'].map((item, i) => (
                  <li key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, fontSize: 14 }}>
                    <span style={{ color: '#86efac' }}>&#10003;</span> {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {/* Pulsante Paga Ora */}
          <div style={{ marginTop: 40 }}>
            <button onClick={handleCheckout} disabled={checkoutLoading} className="btn btn-lg btn-green" style={{ fontSize: 18, padding: '18px 48px', border: 'none', cursor: checkoutLoading ? 'wait' : 'pointer' }}>
              {checkoutLoading ? 'Caricamento...' : 'Paga €1.000 (IVA inclusa) — Avvia la Pratica'}
            </button>
            <p style={{ fontSize: 13, opacity: 0.7, marginTop: 10 }}>Pagamento sicuro con Stripe. Dopo il pagamento verrai ricontattato entro 24 ore.</p>
          </div>

          {/* Esempio pratico */}
          <div style={{
            background: 'rgba(255,255,255,0.1)', borderRadius: 12, padding: 24,
            maxWidth: 700, margin: '40px auto 0', border: '1px solid rgba(255,255,255,0.15)'
          }}>
            <p style={{ fontWeight: 700, fontSize: 16, marginBottom: 12 }}>Esempio Pratico</p>
            <p style={{ fontSize: 14, opacity: 0.9, lineHeight: 1.8, margin: 0 }}>
              Per un contributo approvato di <strong>€50.000</strong>, il costo totale del servizio sarà:<br />
              €1.000 (anticipo) + €2.500 (5% di €50.000) = <strong>€3.500 totali</strong><br />
              <span style={{ opacity: 0.7 }}>Il tuo guadagno netto: €46.500 — un ritorno di oltre 13x sull'investimento.</span>
            </p>
          </div>
        </div>
      </section>

      {/* Perché Scegliere Noi */}
      <section className="section" style={{ background: '#f8fafc' }}>
        <div className="container">
          <h2 className="section-title">Perché Affidarti a Noi</h2>
          <div className="grid-2" style={{ gap: 24 }}>
            {[
              { icon: '🎯', title: 'Specializzazione Verticale', desc: 'Non siamo un generico studio di consulenza. Siamo specializzati esclusivamente in incentivi e agevolazioni per le imprese italiane.' },
              { icon: '📊', title: 'Tasso di Successo 90%+', desc: 'La nostra selezione accurata dei bandi e la qualità della documentazione ci permettono di mantenere un tasso di approvazione superiore al 90%.' },
              { icon: '🤝', title: 'Interessi Allineati', desc: 'Con il modello a success fee, il nostro guadagno è proporzionale al tuo. Abbiamo tutto l\'interesse a farti ottenere il massimo contributo possibile.' },
              { icon: '⚡', title: 'Velocità di Esecuzione', desc: 'Conosciamo i portali, le procedure e le tempistiche. Prepariamo e presentiamo le pratiche in tempi record, senza rischiare di perdere le scadenze.' }
            ].map((item, i) => (
              <div key={i} className="card" style={{ display: 'flex', gap: 16, alignItems: 'flex-start', padding: 28 }}>
                <div style={{ fontSize: 32, flexShrink: 0 }}>{item.icon}</div>
                <div>
                  <h3 style={{ fontSize: 17, fontWeight: 700, marginBottom: 8, color: '#111827' }}>{item.title}</h3>
                  <p style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.7, margin: 0 }}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonianze */}
      <section className="section" style={{ background: 'white' }}>
        <div className="container">
          <h2 className="section-title">Risultati Reali dei Nostri Clienti</h2>
          <p className="section-subtitle">Imprenditori come te che hanno trasformato le opportunità in contributi concreti</p>
          <div className="grid-3">
            {testimonials.map((t, i) => (
              <div key={i} className="testimonial" style={{ position: 'relative', paddingTop: 32 }}>
                <div style={{
                  position: 'absolute', top: -16, left: '50%', transform: 'translateX(-50%)',
                  background: 'linear-gradient(135deg, #16a34a, #15803d)', color: 'white',
                  padding: '6px 16px', borderRadius: 20, fontSize: 13, fontWeight: 700
                }}>
                  Contributo ottenuto: {t.amount}
                </div>
                <div className="stars" style={{ marginTop: 8 }}>&#9733;&#9733;&#9733;&#9733;&#9733;</div>
                <div className="quote">"{t.quote}"</div>
                <div className="author">{t.author}</div>
                <div className="role">{t.role}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Garanzia */}
      <section className="section" style={{ background: '#f0fdf4' }}>
        <div className="container" style={{ textAlign: 'center', maxWidth: 700 }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🛡️</div>
          <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 16, color: '#111827' }}>La Nostra Garanzia</h2>
          <p style={{ fontSize: 16, color: '#4b5563', lineHeight: 1.8, marginBottom: 24 }}>
            Siamo talmente sicuri della qualità del nostro lavoro che la maggior parte del nostro compenso è legata al tuo successo.
            <strong> Paghi il 5% solo sull'importo effettivamente approvato e deliberato.</strong> Se il bando non viene approvato, non dovrai pagare la success fee.
          </p>
          <p style={{ fontSize: 14, color: '#6b7280' }}>
            Consulentecrediti S.r.l.s. — P.IVA 06139990870 — Società regolarmente iscritta alla Camera di Commercio
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="section" style={{ background: 'white' }}>
        <div className="container" style={{ maxWidth: 800 }}>
          <h2 className="section-title">Domande Frequenti</h2>
          <p className="section-subtitle">Tutto quello che devi sapere sul servizio di Gestione Bandi</p>
          {faqs.map((faq, i) => (
            <div key={i} className="faq-item">
              <div className="faq-question" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                <span>{faq.q}</span>
                <span style={{ fontSize: 20, transition: 'transform 0.2s', transform: openFaq === i ? 'rotate(45deg)' : 'none' }}>+</span>
              </div>
              {openFaq === i && (
                <div className="faq-answer">{faq.a}</div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* CTA + Form */}
      <section id="contattaci" className="section" style={{ background: 'linear-gradient(135deg, #1a56db 0%, #0f3a8e 50%, #16a34a 100%)', color: 'white' }}>
        <div className="container">
          <div className="grid-2" style={{ alignItems: 'center', gap: 48 }}>
            <div>
              <h2 style={{ fontSize: 32, fontWeight: 700, marginBottom: 16 }}>Pronto a Ottenere i Tuoi Incentivi?</h2>
              <p style={{ fontSize: 16, opacity: 0.9, lineHeight: 1.8, marginBottom: 24 }}>
                Non lasciare che la burocrazia ti impedisca di accedere ai fondi che meriti. Contattaci oggi per una consulenza gratuita e senza impegno.
              </p>
              <div style={{ marginBottom: 24 }}>
                <a
                  href="https://wa.me/393484932900?text=Salve%2C%20sono%20interessato%20al%20servizio%20di%20Gestione%20Bandi.%20Vorrei%20maggiori%20informazioni."
                  className="btn btn-lg btn-green"
                  style={{ fontSize: 17, padding: '16px 36px', width: '100%', justifyContent: 'center' }}
                >
                  Contattaci su WhatsApp
                </a>
                <p style={{ fontSize: 13, opacity: 0.7, marginTop: 8, textAlign: 'center' }}>
                  Risposta garantita entro 2 ore lavorative
                </p>
              </div>
              <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 12, padding: 20 }}>
                <p style={{ fontWeight: 600, marginBottom: 8 }}>Contatti Diretti:</p>
                <p style={{ fontSize: 14, opacity: 0.9, marginBottom: 4 }}>WhatsApp: +39 348 493 2900</p>
                <p style={{ fontSize: 14, opacity: 0.9, marginBottom: 4 }}>Email: info@verificaincentivi.it</p>
                <p style={{ fontSize: 14, opacity: 0.9 }}>Lun-Ven: 9:00 - 18:00</p>
              </div>
            </div>
            <div>
              <div style={{ background: 'white', borderRadius: 16, padding: 32, color: '#111827' }}>
                <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 4, textAlign: 'center' }}>Richiedi Informazioni</h3>
                <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 20, textAlign: 'center' }}>Compila il modulo e ti ricontatteremo entro 24 ore</p>
                {formStatus === 'success' ? (
                  <div style={{ textAlign: 'center', padding: 20 }}>
                    <div style={{ fontSize: 48, marginBottom: 12 }}>✅</div>
                    <h3 style={{ color: '#16a34a', marginBottom: 8 }}>Richiesta Inviata!</h3>
                    <p style={{ color: '#6b7280', fontSize: 14 }}>Ti ricontatteremo entro 24 ore lavorative. Per una risposta immediata, contattaci su WhatsApp.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label>Nome e Cognome *</label>
                      <input type="text" required value={formData.nome} onChange={e => setFormData({...formData, nome: e.target.value})} placeholder="Mario Rossi" />
                    </div>
                    <div className="form-group">
                      <label>Email *</label>
                      <input type="email" required value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} placeholder="mario@azienda.it" />
                    </div>
                    <div className="form-group">
                      <label>Telefono *</label>
                      <input type="tel" required value={formData.telefono} onChange={e => setFormData({...formData, telefono: e.target.value})} placeholder="+39 333 1234567" />
                    </div>
                    <div className="form-group">
                      <label>Nome Azienda</label>
                      <input type="text" value={formData.azienda} onChange={e => setFormData({...formData, azienda: e.target.value})} placeholder="La Tua Azienda S.r.l." />
                    </div>
                    <div className="form-group">
                      <label>Messaggio</label>
                      <textarea rows="3" value={formData.messaggio} onChange={e => setFormData({...formData, messaggio: e.target.value})} placeholder="Descrivi brevemente la tua esigenza o il bando di interesse..." style={{ resize: 'vertical' }} />
                    </div>
                    {formStatus === 'error' && (
                      <p style={{ color: '#dc2626', fontSize: 13, marginBottom: 12 }}>Errore nell'invio. Riprova o contattaci su WhatsApp.</p>
                    )}
                    <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={sending}>
                      {sending ? 'Invio in corso...' : 'Invia Richiesta'}
                    </button>
                    <p style={{ fontSize: 11, color: '#9ca3af', marginTop: 8, textAlign: 'center' }}>
                      Inviando il modulo accetti la nostra <a href="/privacy-policy" style={{ color: '#1a56db' }}>Privacy Policy</a>
                    </p>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Bar */}
      <section style={{ background: '#f8fafc', padding: '24px 0', textAlign: 'center' }}>
        <div className="container">
          <p style={{ fontSize: 13, color: '#9ca3af' }}>
            Consulentecrediti S.r.l.s. — P.IVA 06139990870 — Via Ravanusa N.13, 95030 Tremestieri Etneo (CT) — info@verificaincentivi.it
          </p>
        </div>
      </section>
    </div>
  );
}
